import { ArticlePreviewResponse, ContentResponse } from "authory-api-types/dist/types";

export const contentHasDefaultPreview = (content?: ContentResponse | ArticlePreviewResponse) => content && content.ogTitle !== null;